import useAxiosPrivate from "../hooks/useAxiosPrivate";
import config from "../config";

export const useUserService = () => {
  const axiosPrivate = useAxiosPrivate();

  const deleteAccount = async (reason = "") => {
    try {
      const response = await axiosPrivate.delete(
        config.API.USERS.DELETE_ACCOUNT,
        {
          data: { reason },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting account:", error);
      throw error;
    }
  };

  const createSupportTicket = async (subject, message) => {
    try {
      const response = await axiosPrivate.post(
        config.API.SUPPORT.CREATE_TICKET,
        {
          subject,
          message,
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error creating support ticket:", error);
      throw error;
    }
  };

  return {
    deleteAccount,
    createSupportTicket,
  };
};
